"use client";

import { usePathname } from "next/navigation";
import type { ReactNode } from "react";

interface AppChromeProps {
  header: ReactNode;
  footer: ReactNode;
  children: ReactNode;
}

/** Hides site chrome on full-screen interstitial routes (e.g. booking redirect). */
export function AppChrome({ header, footer, children }: AppChromeProps) {
  const pathname = usePathname();
  const hideChrome = pathname === "/redirect";

  return (
    <>
      {!hideChrome && header}
      {children}
      {!hideChrome && footer}
    </>
  );
}
